import { useState, useEffect } from 'react';
import { useApi } from './useApi';

export const usePublicite = () => {
  const { apiCall, API_BASE_URL } = useApi();
  const [publicites, setPublicites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPublicites = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Utiliser les vraies données API maintenant
      
      const data = await apiCall(`/publicites`);
      console.log('✅ API Success - Publicites:', data);
      
      setPublicites(data);
    } catch (err) {
      console.error('❌ API Error - Publicites:', err);
      setError(err.message);
      
      // Données fallback pour le développement
      const fallbackData = [
        {
          id: '67',
          business_name: 'ProActiveGestion SAS',
          avatar_url: '/avatars/proactive.png',
          start_date: '11/07/2025',
          end_date: '11/07/2025',
          emplacement: 'Accueil',
          cost_per_view: 350,
          status: 'active'
        },
        {
          id: '89',
          business_name: 'SantéSûr Coopérative',
          avatar_url: '/avatars/santesur.png',
          start_date: '5/07/2025',
          end_date: '5/07/2025',
          emplacement: 'Recherche',
          cost_per_view: 350,
          status: 'draft'
        },
        {
          id: '24',
          business_name: 'NexusConseil SAS',
          avatar_url: '/avatars/nexus.png',
          start_date: '12/04/2025',
          end_date: '12/04/2025',
          emplacement: 'Pop up',
          cost_per_view: 350,
          status: 'paused'
        },
        {
          id: '27',
          business_name: 'Artisanat Raffiné SARL',
          avatar_url: '/avatars/artisanat.png',
          start_date: '7/18/2025',
          end_date: '7/18/2025',
          emplacement: 'Pop up',
          cost_per_view: 350,
          status: 'completed'
        }
      ];
      setPublicites(fallbackData);
    } finally {
      setLoading(false);
    }
  };

  const updatePubliciteStatus = async (id, status, reason = null) => {
    try {
      console.log('🔄 Updating publicite status:', { id, status, reason });
      
      const data = await apiCall(`/publicites/${id}/status`, {
        method: 'PUT',
        body: JSON.stringify({ status, reason })
      });

      console.log('✅ Status updated successfully:', data);

      // Refetch data after update
      await fetchPublicites();
      
      return true;
    } catch (err) {
      console.error('❌ API Error - Update Publicite Status:', err);
      setError(err.message);
      return false;
    }
  };

  const deletePublicite = async (id) => {
    try {
      const data = await apiCall(`/publicites/${id}`, {
        method: 'DELETE'
      });

      console.log('✅ Publicite deleted successfully:', data);

      // Remove from local state
      setPublicites(prev => prev.filter(pub => pub.id !== id));
      
      return true;
    } catch (err) {
      console.error('❌ API Error - Delete Publicite:', err);
      setError(err.message);
      return false;
    }
  };

  useEffect(() => {
    fetchPublicites();
  }, []);

  return {
    publicites,
    loading,
    error,
    fetchPublicites,
    updatePubliciteStatus,
    deletePublicite
  };
};

export const usePubliciteDetail = (id) => {
  const { apiCall, API_BASE_URL } = useApi();
  const [publicite, setPublicite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPublicite = async () => {
    if (!id) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const data = await apiCall(`/publicites/${id}`);
      console.log('✅ API Success - Publicite Detail:', data);
      
      setPublicite(data);
    } catch (err) {
      console.error('❌ API Error - Publicite Detail:', err);
      setError(err.message);
      
      // Données fallback pour le développement
      const fallbackData = {
        id: parseInt(id),
        business_name: 'ProActiveGestion SAS',
        avatar_url: '/avatars/proactive.png',
        start_date: '11/07/2025',
        end_date: '11/07/2025',
        emplacement: 'Accueil',
        cost_per_view: 350,
        status: 'active',
        reason: null
      };
      setPublicite(fallbackData);
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (status, reason = null) => {
    try {
      const data = await apiCall(`/publicites/${id}/status`, {
        method: 'PUT',
        body: JSON.stringify({ status, reason })
      });

      console.log('✅ Status updated successfully:', data);

      // Refetch data after update
      await fetchPublicite();
      
      return true;
    } catch (err) {
      console.error('❌ API Error - Update Status:', err);
      setError(err.message);
      return false;
    }
  };

  useEffect(() => {
    fetchPublicite();
  }, [id]);

  return {
    publicite,
    loading,
    error,
    fetchPublicite,
    updateStatus
  };
};